import React from "react";
import { merge } from "lodash";
import Notification, { NotificationProps as BaseNotificationProps, NotificationOptions } from "./Notification";

export type ErrorNotificationProps =
    Pick<BaseNotificationProps, "id" | "message" | "onClose"> &
    Partial<Omit<BaseNotificationProps, "id" | "message" | "onClose">> & {
        options?: NotificationOptions;
    };

const defaultOptions: NotificationOptions = {
    containerClass: "text-error-900 bg-error-100 rounded-md border border-error-900",
    iconSrc: "/icons/x-circle.svg"
};

export const ErrorNotification: React.FC<ErrorNotificationProps> = ({
    containerClass,
    iconSrc,
    id,
    message,
    options = {},
    // Callbacks
    onClose,
    // Rest
    ...restOfBaseProps
}) => {
    const mergedOptions: NotificationOptions = merge({}, defaultOptions, options);

    return (
        <Notification
            containerClass={containerClass || mergedOptions.containerClass}
            iconSrc={iconSrc || mergedOptions.iconSrc}
            iconClass={mergedOptions.iconClass}
            buttonClass={mergedOptions.buttonClass}
            buttonIcon={mergedOptions.buttonIcon}
            id={id}
            message={message}
            // Callbacks
            onClose={onClose}
            // Rest
            {...restOfBaseProps}
        />
    );
};

export default ErrorNotification;